/*
 * Slim v5.0.0 - Image Cropping Made Easy
 * Copyright (c) 2018 Rik Schennink - http://slimimagecropper.com
 */
// Necessary React Modules
import React from 'react'
import ReactDOM from 'react-dom'

// Slim (place slim CSS and module js file in same folder as this file)
import Slim from './slim.module.js'
import './slim.min.css'

export interface ISlimProps {
  name: string
  initialImage?: any
  ratio?: string
  label?: string

  size?: {width: number; height: number}
  didConfirm?: (data: any) => void
  didTransform?: (data: any) => void
  //didLoad?: (file, image, meta) => void
  didRemove?: (data: any) => void
}

interface IState {
  displayWidth: string | number
}
// React Component
export default class extends React.Component<ISlimProps, IState> {
  private instance: any
  private containerRef: HTMLDivElement | null = null

  /**
   *
   */
  constructor(props: ISlimProps) {
    super(props)

    this.state = {displayWidth: 'auto'}
  }

  public componentDidMount() {
    const root = ReactDOM.findDOMNode(this)
    if (this.props.initialImage && root) {
      const img = document.createElement('img')
      img.setAttribute('alt', '')
      img.src = this.props.initialImage
      root.appendChild(img)
    }
    this.instance = Slim ? Slim.create(root, this.props) : null

    this.setDisplayWidth()
  }

  public render() {
    const {displayWidth} = this.state
    const {name} = this.props
    return (
      <div
        ref={(ref) => (this.containerRef = ref)}
        style={{width: displayWidth}}>
        {this.props.children}
        <input name={name} type="file" />
      </div>
    )
  }

  private setDisplayWidth() {
    const {
      size: {width},
    } = this.props
    const displayWidth =
      this.containerRef !== null && this.containerRef.offsetWidth >= width
        ? width
        : 'auto'
    this.setState({displayWidth})
  }
}
